import type { Container, Ticker } from 'pixi.js';

import type { GameWorldSnapshot } from '../engine/world/types';
import { DebugPanel } from './DebugPanel';
import { EventTicker } from './EventTicker';
import { ResourcePanel } from './ResourcePanel';
import { WeatherBadge } from './WeatherBadge';

export class OverlayHUD {
  private readonly resources = new ResourcePanel();
  private readonly ticker = new EventTicker();
  private readonly debug = new DebugPanel();
  private readonly weather = new WeatherBadge();

  constructor(layer: Container, options: { showDebug?: boolean; visualPolish?: boolean } = {}) {
    if (options.visualPolish) {
      this.resources.setPolishMode();
      this.ticker.setPolishMode();
    }
    layer.addChild(this.resources.root, this.ticker.root, this.weather.root);
    if (options.showDebug) layer.addChild(this.debug.root);
  }

  update(snapshot: GameWorldSnapshot, pixiTicker: Ticker): void {
    this.resources.update(snapshot.resources, snapshot.progressionLevel, snapshot.season, snapshot.gameplay);
    this.ticker.update(snapshot.activeEvents);
    this.weather.update(snapshot.season, pixiTicker);
    this.debug.update(snapshot, pixiTicker);
  }
}
